export default {
  title: "Férias - Mudanças no quadro de horários para as linhas metropolitanas",
  resume: "As linhas metropolitanas, entre os dias 11/07 e 02/08 operam no quadro de horários de férias",
  img: "/news/ferias.jpg",
  publishDate: "2026-07-10T00:00:00.000-03:00",
  // fixed: true,
  content: [
    "As linhas metropolitanas operam entre os dias 11/07 e 02/08 no quadro de horários de férias. Há redução das partidas e maior intervalo entre as viagens.",
    "<>As reduções variaram bastante entre as linhas, mas chegaram até 30% (é o caso da <Link to={\"/lines/20\"}>linha 4987</Link>).<>",
    "<>Para verificar os horários da linha metropolitana de seu interesse, <Link to={\"/search/?term=metropolitano\"}>acesse a nossa página de pesquisa</Link>.</>",
    "Não foi anunciada mudança no quadro de horários das linhas municipais, nem aquelas que passaram a ser operadas pela Prefeitura Municipal.",
    "<>Notícia relacionada à <Link to={\"/news/15\"}>Remoção dos horários de partida e informaçÕes para todas as linhas municipais</Link></>"
  ],
};
